import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { categories, tvShows } from '@/mocks/tvShows';
import ShowCard from '@/components/feature/ShowCard';

const slides = [
  {
    id: 'qing-yu-nian-2',
    title: '庆余年 第二季',
    description: '张若昀领衔权谋大戏回归，范闲运筹帷幄，庆国风云再起',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20palace%20courtyard%20with%20dramatic%20cinematic%20lighting%20golden%20hour%20warm%20tones%20ancient%20Chinese%20architecture%20grandeur%20mysterous%20atmosphere%20with%20fog%20and%20mist%20high%20detail%20cinematic%20composition%208K&width=1600&height=700&seq=hero-slide-01&orientation=landscape',
    rating: '9.5',
  },
  {
    id: 'fan-hua',
    title: '繁花',
    description: '王家卫首部电视剧，胡歌演绎上海滩风云传奇',
    image: 'https://readdy.ai/api/search-image?query=Retro%20Shanghai%201990s%20cityscape%20at%20golden%20sunset%20with%20neon%20signs%20and%20classic%20old%20buildings%20along%20the%20Bund%20nostalgic%20warm%20amber%20tones%20Wong%20Kar-wai%20aesthetic%20cinematic%20wide%20shot%20atmospheric%20haze&width=1600&height=700&seq=hero-slide-02&orientation=landscape',
    rating: '9.4',
  },
  {
    id: 'kuang-biao',
    title: '狂飙',
    description: '张译张颂文演技巅峰对决，二十年正邪较量',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20cityscape%20at%20dusk%20with%20dramatic%20storm%20clouds%20gathering%20overhead%20dark%20moody%20atmosphere%20tension%20and%20power%20contrast%20cinematic%20wide%20angle%20shot%20urban%20skyline%20silhouette%20against%20brooding%20sky&width=1600&height=700&seq=hero-slide-03&orientation=landscape',
    rating: '9.6',
  },
];

export default function HomeHero() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const goToDetail = (id: string) => {
    navigate(`/detail/${id}`);
  };

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {slides.map((slide, index) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-1000 ${
            index === currentSlide ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/50"></div>
        </div>
      ))}

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-7xl mx-auto w-full">
            <div className="max-w-2xl">
              <div className="flex items-center gap-2 mb-4">
                <span className="bg-accent-500 text-background-50 text-xs px-2.5 py-1 rounded-full font-medium whitespace-nowrap">
                  热播推荐
                </span>
                <div className="flex items-center gap-1 text-amber-400 text-sm">
                  <i className="ri-star-fill"></i>
                  <span className="font-bold">{slides[currentSlide].rating}</span>
                </div>
              </div>
              <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 font-heading">
                {slides[currentSlide].title}
              </h2>
              <p className="text-sm md:text-base text-white/80 mb-6 leading-relaxed max-w-lg">
                {slides[currentSlide].description}
              </p>
              <div className="flex items-center gap-3 flex-wrap">
                <button
                  onClick={() => goToDetail(slides[currentSlide].id)}
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-play-circle-fill text-lg"></i>
                  立即观看
                </button>
                <Link
                  to={`/category/all`}
                  className="inline-flex items-center gap-1 px-5 py-3 bg-white/20 backdrop-blur-sm text-white rounded-full text-sm font-medium hover:bg-white/30 transition-colors cursor-pointer whitespace-nowrap"
                >
                  浏览全部剧集
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-0 right-0">
        <div className="flex items-center justify-center gap-2">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                index === currentSlide
                  ? 'bg-white w-6'
                  : 'bg-white/40 hover:bg-white/60'
              }`}
              aria-label={`切换到第${index + 1}张`}
            />
          ))}
        </div>
      </div>
    </section>
  );
}